import { render } from "./SpeakersView.vue?vue&type=template&id=6534f346&scoped=true"
import script from "./SpeakersView.vue?vue&type=script&lang=js"
export * from "./SpeakersView.vue?vue&type=script&lang=js"

import "./SpeakersView.vue?vue&type=style&index=0&id=6534f346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6534f346"]])

export default __exports__